import { render } from "./ResumedCharts.vue?vue&type=template&id=1849df07"
import script from "./ResumedCharts.vue?vue&type=script&lang=js"
export * from "./ResumedCharts.vue?vue&type=script&lang=js"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__